import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { NAV_LINKS } from "../data/content";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const to = (href) => {
    if (href.startsWith("/")) return href; // rota dedicada (ex.: /contactos)
    return isHome ? href : `/${href}`; // âncora na home
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 border-b border-black/5 backdrop-blur-xl transition-colors duration-300 ${
        scrolled ? "bg-white/80" : "bg-white/40"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href={to("#inicio")} data-testid="header-logo" className="flex items-center gap-3">
          <img
            src="/images/logo.png"
            alt="INN.PACT — Clínica de Imagem em Leiria (logótipo)"
            className="h-16 w-auto object-contain"
            fetchPriority="high"
            decoding="sync"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={to(link.href)}
              data-testid={`nav-link-${link.href.slice(1)}`}
              className="label-editorial text-black/60 hover:text-clay transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
          <a
            href={to("#marcacoes")}
            data-testid="header-booking-cta"
            className="label-editorial bg-clay text-white px-6 py-3 hover:bg-clay-dark transition-colors duration-300"
          >
            Agendar
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden bg-white border-t border-black/5 px-6 py-6 flex flex-col gap-5">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={to(link.href)}
              onClick={() => setOpen(false)}
              className="label-editorial text-black/70 hover:text-clay"
            >
              {link.label}
            </a>
          ))}
          <a
            href={to("#marcacoes")}
            onClick={() => setOpen(false)}
            data-testid="mobile-booking-cta"
            className="label-editorial bg-clay text-white px-6 py-3 text-center hover:bg-clay-dark transition-colors duration-300"
          >
            Agendar
          </a>
        </nav>
      )}
    </header>
  );
};
